import { ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { map, mapTo, mergeMap, switchMap, tap } from 'rxjs/operators';
import socketLaunch from '../../../core/socket/socket.client';
import util from '../../../core/utils';
import { Type as SysType } from '../redux';
import { Type } from './redux';

let socket;
const wsConnect = action$ =>
  action$.pipe(
    ofType(Type.WS_CONNECT),
    switchMap(({ token }) =>
      Observable.create(ob => {
        socketLaunch(token, ob);
      }),
    ),
    tap(inst => {
      socket = inst;
      util.ls.set(util.ls.LS_KEYS.TP_RESTORE_FLAG, true);
    }),
    mapTo({ type: Type.CONNECTED, connected: true }),
  );

const wsRegister = action$ =>
  action$.pipe(
    ofType(Type.REGISTER),
    mergeMap(({ stubNames }) =>
      Observable.create(ob => {
        util.log.p('wsregister', stubNames, socket);

        // 监听注册的事件（传输的页面内容事件）
        stubNames.forEach(stubName => {
          socket.on(stubName, payload => {
            console.log('==> client recieved data: ', payload);

            // 监听到对应的事件，传值
            ob.next(payload);
          });
        });
      }),
    ),

    // 接收到事件，触发PULL
    map(payload => ({ type: Type.PULL, payload })),
  );

// 拉数据，保存到redux里
const pullDataProcessor = (action$, state$) =>
  action$.pipe(
    ofType(Type.PULL),
    tap(() => {
      util.ls.set(
        util.ls.LS_KEYS.TP_WS_PULL,
        state$.value.mirroring.ws.socketData,
      );
      util.ls.set(util.ls.LS_KEYS.TP_ROOM_ID, state$.value.mirroring.ws.roomId);

      const {
        mirroring: { sys, ...rest },
      } = state$.value;
      util.ls.set(util.ls.LS_KEYS.TP_REDUX_STATE_TREE, {
        mirroring: {
          ...rest,
        },
      });
    }),
    map(({ payload }) => ({
      type:
        !payload.pageName ||
        payload.pageName === state$.value.mirroring.ws.pageName
          ? SysType.SWALLOW_IT
          : Type.GOTO_PAGE,
      pageName: payload.pageName,
    })),
  );

// 推数据
const wsPush = (action$, state$) =>
  action$.pipe(
    ofType(Type.PUSH),
    switchMap(({ stubName, payload }) => {
      util.log.p('push data:', stubName, {
        ...payload,
        roomId: state$.value.mirroring.ws.roomId,
      });
      socket.emit(stubName, {
        ...payload,
        roomId: state$.value.mirroring.ws.roomId,
      });
      return of(payload);
    }),
    mapTo({ type: SysType.SWALLOW_IT }),
  );

// 退出连接，关闭socket清除数据
const disconnect = action$ =>
  action$.pipe(
    ofType(Type.DISCONNECT),
    tap(() => {
      socket.close();
      util.ls.del(util.ls.LS_KEYS.TP_RESTORE_FLAG);
      util.ls.del(util.ls.LS_KEYS.TP_PAGE_NAME);
      util.ls.del(util.ls.LS_KEYS.TP_WS_PULL);
      util.ls.del(util.ls.LS_KEYS.TP_ROOM_ID);
      util.ls.del(util.ls.LS_KEYS.TP_REDUX_STATE_TREE);
    }),
    mapTo({ type: SysType.SWALLOW_IT }),
  );

// 跳转到对应页面，当前页面存到redux
const gotoPage = (action$, state$) =>
  action$.pipe(
    ofType(Type.GOTO_PAGE),
    tap(() => {
      util.ls.set(
        util.ls.LS_KEYS.TP_PAGE_NAME,
        state$.value.mirroring.ws.pageName,
      );
      util.ls.set(util.ls.LS_KEYS.TP_REDUX_STATE_TREE, state$.value);
    }),
    mapTo({ type: SysType.SWALLOW_IT }),
  );

// const restorePageNameFromLS = action$ =>
//   action$.pipe(
//     ofType(Type.CONNECTED),
//     switchMap(() =>
//       of({
//         pageName:
//           util.ls.get(util.ls.LS_KEYS.TP_PAGE_NAME) ?? MIRRORING_PAGENAME.LOGIN,
//         roomId: util.ls.get(util.ls.LS_KEYS.TP_ROOM_ID) ?? null,
//         socketData: util.ls.get(util.ls.LS_KEYS.TP_WS_PULL) ?? {},
//       }),
//     ),
//     map(restoreData => {
//       return { type: Type.RESTORE, ...restoreData };
//     }),
//   );

export default [
  wsConnect,
  wsRegister,
  wsPush,
  pullDataProcessor,
  disconnect,
  gotoPage,
  // restorePageNameFromLS,
];
